import Swiper from 'swiper/bundle';

$(function() {
	handleFactsSwiper();
});


function handleFactsSwiper() {
	var swiper = new Swiper('.get-the-facts .swiper', {
		mousewheel: false,
		initialSlide: 0,
		grabCursor: true,
		centeredSlides: false,
		slidesPerView: 2,
		initialSlide: 0,
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
			hide: false,
		},
		breakpoints: {
			480: {
				slidesPerView: 3,
			},
			992: {
				slidesPerView: 4,
			},
		},
	});

}